import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';

export const clipsQueryKeys = {
  all: ['clips'] as const,

  infinite: () => [...clipsQueryKeys.all, 'infinite'] as const,
  infiniteList: (filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...clipsQueryKeys.infinite(), filters] as const,

  // The id has to be part of the key: without it two programmes, or two segments, share
  // one accumulated entry and show each other's cuts.
  infiniteByProgram: (id: string, filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...clipsQueryKeys.infinite(), 'program', id, filters] as const,
  infiniteBySegment: (id: string, filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...clipsQueryKeys.infinite(), 'segment', id, filters] as const,

  byId: (id: string, filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...clipsQueryKeys.all, id, filters] as const,
  bySegment: (id: string, filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...clipsQueryKeys.all, 'segment', id, filters] as const,
};
